export const siteUrl = "https://farol.no-olvidar.com"
export const adClient = 'ca-pub-5852214892507568'
export const adSlotInArticle = "4044594475"
export const facebookUrl = "https://www.facebook.com/nolvidar"
export const twitterUrl = "https://twitter.com/kosaschidas"
export const tiktokUrl = "https://www.tiktok.com/@kosaschidas"
export const instagramUrl = "https://www.instagram.com/noolvidarmedios/"
export const discordUrl = "https://discord.gg/n6MQ2X243S"